export default {
    status(score) {
        let status = 'very_low';
        switch (true) {
            case (score < 596):
                status = 'very_low';
                break;
            case (score < 766):
                status = 'low';
                break;
            case (score < 896):
                status = 'normal';
                break;
            case (score < 951):
                status = 'high';
                break;
            case (score >= 951):
                status = 'very_high';
                break;
        }

        return status;
    }
}
